import * as React from 'react';
import { useRouter } from 'next/router';
import Layout from '../../components/Layout';
import { withApollo } from '../../lib/apollo';
import SpeakerDetail from '../../components/speaker/SpeakerDetail';


const Page = () => {
    const router = useRouter();
    const { slug } = router.query;
    const speaker = {
        name: 'Omar Dhalla',
        slug,
        location: 'Toronto, Canada',
        image: {
            imageCoverPreview: 'https://aiml.events/media/CACHE/images/image/f0/18/f0186d3186194aff8737e63461fa302e/1f3b054c5f910a68a0522bdd2d08d716.jpg',
            image: 'https://aiml.events/media/CACHE/images/image/f0/18/f0186d3186194aff8737e63461fa302e/1f3b054c5f910a68a0522bdd2d08d716.jpg',
        },
        resume: `<p>Omar was the first person on the ground in Ontario for both Element AI and Real Ventures in Toronto/Waterloo. In his current role with Element AI as SVP Solutions, Strategy and Corporate Development, he is focused on delivering AI-driven strategies and solutions to enterprise partners while establishing the company's global market presence. At Real Ventures, he established the fund’s Ontario ecosystem operations and led multiple deals with a focus on artificial intelligence, internet-of-things, and financial technology.</p>
        <p>He started his career as a technology & strategy consultant with Accenture and McKinsey. The combination of this background and his experiences co-founding businesses in the packaged goods and media industries allows him to help entrepreneurs at all stages. He is a big believer in the power of community and feels lucky to participate in multiple startup ecosystems across Canada. Omar holds an MBA from the Richard Ivey School of Business at Western Ontario and teaches in University of British Columbia’s EMBA program.</p>`,
        linkedin: 'omardhalla',
        twitter: 'omardhalla',
        facebook: 'omar.dhalla',
        events: {
            edges: [{
                node: {
                    name: 'CrossOver: AI',
                    slug: 'crossover-ai',
                    date: 'December 8 - 9, 2019',
                    image: {
                        imagePreview: 'https://aiml.events/media/CACHE/images/image/7a/02/7a02cd02eb9a4f52aec34c4a04244d0c/56f8f39db076f00931d189e99b1afbfb.jpg',
                    },
                    place: 'Vancouver, Canada',
                },
                bio: 'SVP Solutions, Strategy & Corporate Development, Element.AI',
            }]
        },
    };
    return (
        <Layout>
            <SpeakerDetail speaker={speaker} />
        </Layout>
    );
};
export default withApollo(Page);
